import { createSlice } from "@reduxjs/toolkit";

interface AuditState {
  kpis: any[];
  applicationType: number;
}

const initialState: AuditState = {
  kpis: [],
  applicationType: 0,
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setApplicationType(state, action) {
      state.applicationType = action.payload;
    },
  },
});

export const { setApplicationType } = dashboardSlice.actions;
export default dashboardSlice.reducer;
